module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/star_blue-45e84286b47334dcf471424cff26041e.svg";